import Rapid from './Rapid.jpeg'


export const Final = {
Rapid,

}